import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-remove\">\n  <path d=\"M3.5 7.34998H12.5V8.64998H3.5V7.34998Z\" fill=\"black\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol